// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"7e346e1054e4a0c96248","303":"7286d3167d8d4bc92e5f","495":"53787ac4703bac1afcc5"}[chunkId] + ".js";
};